import styled from 'styled-components';
import links from './links/links';
import { matchPath } from 'react-router';
import { useLocation } from 'react-router-dom';
import { Dropdown, Styles } from 'toolkit/components';

const NavMobileContainer = styled.div`
  @media screen and (max-width: 1000px) {
    display: block;
    border-radius: 3px;
    border: 1px solid ${Styles.colors.grey.secondaryDark};
    box-shadow: none;
    margin-right: 18px;
  }
  display: none;
`;

const DropdownToggle = styled.a`
  font-weight: 400;
  width: 100%;
  border-radius: 0;
  border-color: ${Styles.colors.grey.secondaryDark};
  text-align: left;
  text-transform: none;
  padding: 0 12px;
`;

const DropdownNavContainer = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  cursor: pointer;
`;

const trigger = (pathname: string) => {
  return (
    <DropdownToggle>
      {links.map((link: { path: string; name: string }) => {
        const path = !!matchPath(pathname, `/${link.path}`);
        if (path) return link.name;
        return null;
      })}
    </DropdownToggle>
  );
};

function SidebarNavMobile() {
  const { pathname } = useLocation();

  return (
    <NavMobileContainer>
      <DropdownNavContainer>
        <Dropdown
          links={links}
          Trigger={() => trigger(pathname)}
          fullWidth={true}
          triggerArrow={true}
        />
      </DropdownNavContainer>
    </NavMobileContainer>
  );
}

export default SidebarNavMobile;
